import React, { ForwardRefRenderFunction, useImperativeHandle } from 'react';
import { XIcon } from 'lucide-react';
import { useFilterContext } from '../../../controls/FilterContext/FilterContext';
import { Button } from '../../../buttons';
import { TopControllerWrapper } from './TopControllsWraper';
import { TextInput } from '@cmp-src/form/TextInput';
import { SearchIcon } from '@v2/icons';

export type FilterInputHandle = {
  resetFilter: () => void;
  focus: () => void;
};

export interface SelectSearchProps {
  onInputChange?: (value: string) => void;
  filter?: string;
}

export const SelectSearchComponent: ForwardRefRenderFunction<
  FilterInputHandle,
  SelectSearchProps
> = (props, ref) => {
  const { filter: controlledFilter } = props;
  const {
    filter: contextFilter,
    setFilter: setLocationFilter,
    resetFilter: resetLocationFilter
  } = useFilterContext();

  const filter = controlledFilter || contextFilter;
  const inputRef = React.useRef<HTMLInputElement>(null);

  useImperativeHandle(ref, () => ({
    resetFilter: resetLocationFilter,
    focus: () => {
      setTimeout(() => {
        inputRef.current?.focus();
      }, 10);
    }
  }));

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value;
    setLocationFilter(value);
    if (props.onInputChange) {
      props.onInputChange(value);
    }
  };

  return (
    <TopControllerWrapper>
      <TextInput
        leftSlot={[
          <SearchIcon key={0} className="ml-3 size-5 text-gray-500" />
        ]}
        rightSlot={
          filter
            ? [
                <div key={1}>
                  <Button
                    variant="transparentInvisible"
                    icon={() => (
                      <XIcon
                        className="h-3 w-3 cursor-pointer text-gray-500"
                        onClick={() => {
                          resetLocationFilter();
                          if (props.onInputChange) {
                            props.onInputChange('');
                          }
                        }}
                      />
                    )}
                    className="ml-2"
                  />
                </div>
              ]
            : undefined
        }
        ref={inputRef}
        role="search"
        type="text"
        value={filter}
        onChange={handleChange}
        placeholder="Search..."
        wrapperClassName={'border-0'}
        inputClassName={'py-6'}
        disableOutline
      />
    </TopControllerWrapper>
  );
};
export const SelectSearch = React.forwardRef(SelectSearchComponent);
